import React from 'react'
import { Route, Switch } from 'react-router-dom'
import PageLayout from 'layouts/PageLayout'
import { Error } from 'components'

const AppRouter = () => {
  return (
    <Switch>
      <Route
        path='/pay-page/main'
        render={(routeProps) => require('./Main').default(routeProps)}
      />
      <Route
        path='/pay-page/result'
        render={(routeProps) => require('./Result').default(routeProps)}
      />
      <Route
        path='/pay-page/login'
        render={(routeProps) => require('./Login').default(routeProps)}
      />
      <Route path='*'>
        <PageLayout>
          <Error type='404' />
        </PageLayout>
      </Route>
    </Switch>
  )
}

export default AppRouter
